import React from "react";
import {OrbitComponent} from "../../../../../../../../base-components/orbit-component/orbit-component";
import {GamePlayPcHeaderBarFreePlayLabelBox} from "../../../../boxes/game-mode/free-play-label/game-play-pc-header-bar-free-play-label.box";
import {
    IGameContextViewModel
} from "../../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";


export const GamePlayPcHeaderBarFreePlayGameModeComponent = observer(
    class extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        render() {
            const freePlayContext = this.props.gameContext.freePlayContext;


            return (
                <GamePlayPcHeaderBarFreePlayLabelBox>
                    {freePlayContext.currentFreePlayVoucher?.voucherInGameTitle || this.services.translation.translate('FREE_PLAY_VOUCHER_TITLE_FPV')}
                </GamePlayPcHeaderBarFreePlayLabelBox>
            )
        }
    }
);